<!--<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Upload Image

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <div><video #video id="video" width="640" height="480" autoplay></video></div>
        <div><button id="snap" (click)="capture()">Snap Photo</button></div>
        <canvas #canvas id="canvas" width="640" height="480"></canvas>
        <ul>
          <li *ngFor="let c of captures">
            <img src="{{ c }}" height="50" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>-->
<!--<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Upload Image

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <webcam [height]="500" [width]="500" [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                [videoOptions]="videoOptions"
                [imageQuality]="1"
                (cameraSwitched)="cameraWasSwitched($event)"
                (initError)="handleInitError($event)"></webcam>
        <br />
        <button class="actionBtn" (click)="triggerSnapshot();">Take A Snapshot</button>
        <button class="actionBtn" (click)="toggleWebcam();">Toggle Webcam</button>
        <br />
        <button class="actionBtn" (click)="showNextWebcam(true);" [disabled]="!multipleWebcamsAvailable">Next Webcam</button>
        <input id="cameraSwitchCheckbox" type="checkbox" [(ngModel)]="allowCameraSwitch"><label for="cameraSwitchCheckbox">Allow Camera Switch</label>
        <br />
        DeviceId: <input id="deviceId" type="text" [(ngModel)]="deviceId" style="width: 500px">
        <button (click)="showNextWebcam(deviceId);">Activate</button>
      </div>
    </div>
  </div>
</div>-->
<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Upload Image

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body padding-bottom-0px  margin-left-0px">
        <!--<div class="row">
          <div class="col-md-6 padding-right-5px">
            <div><video #video class="vid" autoplay width="225" height="225" (click)="capture()"></video></div>
          </div>
          <div class="col-md-2">
            <div><button class="btn btn-primary" (click)="capture()">Take Photo</button></div>
          </div>

          <div class="col-md-6 padding-left-5px">
            <div><canvas #canvas class="vid" width="225" height="225"></canvas></div>
          </div>
        </div>-->
        <div class="row">
          <div class="col-md-5 col-5 padding-right-0px">
            <label class="margin-bottom-0px color-Checkin">Live Camera</label>
            <div><video #video class="vid" autoplay width="225" height="225"></video></div>
          </div>
          <div class="col-md-2 col-2 margin-left-auto margin-right-auto margin-top-auto margin-bottom-auto text-align-center padding-left-0px padding-right-0px">
    <div><button class="btn  btn-camera" (click)="capture()"><i class="fas fa-camera"></i></button></div>
  </div>

          <div class="col-md-5 col-5 padding-left-0px">
            <label class="margin-bottom-0px color-Assign">Captured Image</label>
            <div><canvas #canvas class="vid" width="225" height="225"></canvas></div>
          </div>

        </div>
        <div class="row margin-top-10">
          
        </div>
        <!--<div class="row">
          <div class="col-md-5">

            <img src="{{Url}}" height="50">
            <img src='{{Url}}' height="50">
           
            <label>{{Url}}</label>

          </div>

        </div>-->




      </div>
      <div class="modal-footer padding-top-10px padding-bottom-10px">
        <!--<button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="offCamera()">Off</button>-->
        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="offCamera()">Cancel</button>
        <button type="button" class="btn font-size-13px actions-btn-prime margin-right-auto" (click)="OnSubmit()">Ok</button>
      </div>
    </div>
  </div>
</div>
